import { HeartFilled, HeartOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { FC, useState } from "react";
import { useSelector } from "react-redux";
import { useQueryClient } from "react-query";
import { RootState } from "store/Reducers";
import AddFavoriteList from "../Details/Components/Options/Components/AddFavoriteList";
import { deleteFavoriteAdvert } from "apps/CustomerPanel/Favorite/Pages/Ads/Services";
import favoriteEndPoints from "apps/CustomerPanel/Favorite/Pages/Ads/EndPoints"

const Favorite: FC<{
  item: any;
  viewType: any;
  mainItem?: any;
  data?: any;
  pageType?: any;
  setData?: any;
}> = ({ item, viewType, mainItem, data, setData, pageType }) => {
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const queryClient = useQueryClient();
  const [selectedRecord, setSelectedRecord] = useState<null | any>(null);
  const [isShowAddToFavoriteModal, setIsShowAddToFavoriteModal] =
    useState(false);


  const handleDeleteAdvertFavoriteList = async () => {
    try {
     
      await deleteFavoriteAdvert(item);
      openNotificationWithIcon("default", "İlan başarıyla listeden kaldırıldı");
     

        let currentData = [...data];
  
        let findItemIndex = currentData.findIndex((currentItem) => {
          if (currentItem?.advertId) {
            return currentItem.advertId === item.id;
          }
          return currentItem.id === item.id;
        });
  
        currentData[findItemIndex]["isFavorite"] = false;
        console.log(currentData);
        setData(currentData);
        queryClient.resetQueries({
          queryKey: favoriteEndPoints.getFavoriteListFilter,
          exact: false,
        });
        queryClient.resetQueries({
          queryKey: favoriteEndPoints.getFavoriteAdvertList,
          exact: false,
        });
      
    } catch (error: any) {
      openNotificationWithIcon("default", error?.message);
      console.error("Favori kaldırma işleminde hata oluştu", error);
    }
  };

  const handleAddToFavorite = async () => {
    if (userInfoes) {
      await setSelectedRecord(item?.advertId ? { id: item.advertId } : item);
      setIsShowAddToFavoriteModal(true);
    } else {
      openNotificationWithIcon(
        "default",
        "Favorilere eklemek için giriş yapınız"
      );
    }
  };

  const isFavorite = mainItem ? mainItem.isFavorite : item.isFavorite;
  const HeartIcon = isFavorite ? HeartFilled : HeartOutlined;
  const iconClass = `${
    viewType === "list" ? "!text-lg top-2 left-2" : "!text-xl top-4 !right-1 md:!right-2"
  } absolute ${isFavorite ? "!text-red-500" : "!text-[#ffc600]"}`;

  return (
    <>
      <HeartIcon
        className={iconClass}
        onClick={
          (e)=>{
            e.preventDefault();
            e.stopPropagation();
            isFavorite ? handleDeleteAdvertFavoriteList() : handleAddToFavorite()

          }
          
         
        }
      />
      <Modal
        open={isShowAddToFavoriteModal}
        onCancel={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsShowAddToFavoriteModal(false);
        }}
      
        footer={false}
        title={false}
        className="favorite-modal-content"
      
      >
        

        <AddFavoriteList
          selectedRecord={selectedRecord}
          onFinish={() => {
            setIsShowAddToFavoriteModal(false);
          
            
  

              let currentData = [...data];
  
              let findItemIndex = currentData.findIndex((currentItem) => {
                if (currentItem?.advertId) {
                  return currentItem.advertId === selectedRecord.id;
                }
                return currentItem.id === selectedRecord.id;
              });
  
              currentData[findItemIndex]["isFavorite"] = true;
  
              setData(currentData);
              queryClient.resetQueries({
                queryKey: favoriteEndPoints.getFavoriteListFilter,
                exact: false,
              });
              queryClient.resetQueries({
                queryKey: favoriteEndPoints.getFavoriteAdvertList,
                exact: false,
              });
            
          }}
        />
  
      </Modal>
    </>
  );
};

export default Favorite;
